module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#star",
      toString: function () {
        return this.url;
      }
    }